import { ExclamationCircleFilled, } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Button, Modal, Spin, Table, Tabs, Tag, } from "antd";
import { LOGGED_USER, TOKEN } from "../../../../variables/constants";
import { toast } from "react-toastify";
import axiosInstance from "../../../../variables/api/axiosInstance";
import { updateBonCommande, validateWithComment, } from "../../../../hooks/useHooks";
import AffecterLotAttestation from "../../components/modals/AffecterLotAttestation";
import SinglePageLayout from "../../../../layout/SinglePageLayout";
import { formatCurrency, formatFrenchDate, getInitiator, isConnectedUser } from "../../../../variables/functions";
import { useNavigate } from "react-router-dom";
import OrdersFiltering from "../../components/OrdersFiltering";

const CompaniesCommandes = () => {
    const [commandes, setCommandes] = useState([]);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState({});
    const [categories, setCategories] = useState([]);
    const [compagnie, setCompagnie] = useState("");
    const [livrerLoading, setLivrerLoading] = useState(false);
    const [selectedCompagnie, setSelectedCompagnie] = useState({});
    const [selectedBonCommandeId, setSelectedBonCommandeId] = useState(null);
    const [affecterLotModal, setAffecterLotModal] = useState(false);
    const [getCommandesLoading, setGetCommandesLoading] = useState(false);
    const [receivedOrders, setReceivedOrders] = useState([])
    const [rejectedOrders, setRejectedOrders] = useState([])
    const [onGoingOrders, setOnGoingOrders] = useState([])
    const [handledOrders, setHandledOrders] = useState([])

    const navigate = useNavigate()

    const reject = (record, updateCommentaire) => {
        const updatedBonCommande = { ...record };
        updatedBonCommande.statutCommande = "REJETE";
        updatedBonCommande.motifRejet = updateCommentaire;
        updateBonCommande(updatedBonCommande).then((r) => {
            setReload((prevState) => !prevState);
            toast.success("Commande rejetée avec succes");
        });
    };
    let com = "";

    console.log(selectedCompagnie);

    console.log(selectedOrder.compagnie);
    const showRejectBonCommandeConfirm = (record) => {
        Modal.confirm({
            title: `Etes-vous sûr de vouloir rejeter la commande?`,
            icon: <ExclamationCircleFilled color={"blue"} />,
            content: (<>
                <p style={{ color: "red", marginBottom: "1rem" }}>
                    Toutes vos actions sont historisées
                </p>
                <div style={{ marginBottom: "1rem" }}>
                    <label htmlFor="commentaire">Motif de rejet :</label>
                    <textarea
                        id="commentaire"
                        style={{
                            width: "100%",
                            marginTop: "0.5rem",
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #d9d9d9",
                        }}
                        placeholder="Votre commentaire ici..."
                        onChange={(e) => {
                            com = e.target.value;
                        }}
                    />
                </div>
            </>),
            okText: "Oui",
            okType: "primary",
            cancelText: "Annuler",
            onOk: () => reject(record, com),
        });
    };

    const [reload, setReload] = useState(false);

    const getAuthorizedDate = (actions) => {
        const action = actions.find((a) => a.action === "AUTORISER");
        return action?.dateAction;
    }

    const getActionVerb = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "valider";
            case "VALIDE":
                return "autoriser";
            case "AUTORISE":
                return "Receptionner ";
            case "EN_TRAITEMENT":
                return "approuver";
            case "APPROUVE":
                return "régler";
            case "REGLE":
                return "livrer";
            case "DELIVRE":
                return "réceptionner";
            default:
                return null;
        }
    };

    console.log(commandes);
    const getTagColor = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "blue";
            case "VALIDE":
                return "green";
            case "AUTORISE":
                return "gold";
            case "CONFIRME":
                return "purple";
            case "DELIVRE":
                return "cyan";
            case "RECEPTIONNE":
                return "volcano";
            default:
                return "default";
        }
    };
    console.log(commandes)
    useEffect(() => {
        const code = LOGGED_USER.profil.organisme.code;
        setLoadingOrders(true);
        setGetCommandesLoading(true);
        axiosInstance
            .get(`/api/bon-commande`)
            .then((res) => {
                setCommandes(res.data.reverse());
                setLoadingOrders(false);
                setGetCommandesLoading(false);
            })
            .catch(() => setLoadingOrders(false));

        axiosInstance
            .get(`/api/categorie`)
            .then((res) => {
                console.log(res.data);
                setCategories(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/organisme/code/${code}`)
            .then((res) => {
                console.log(res.data);
                setCompagnie(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [TOKEN, reload]);

    useEffect(() => {
        setReceivedOrders(commandes?.filter((c) => c.statutCommande === "AUTORISE"))
        setRejectedOrders(commandes?.filter((c) => c.statutCommande === "REJETE"))
        setOnGoingOrders(commandes?.filter((c) => c.statutCommande === "EN_TRAITEMENT" || c.statutCommande === "APPROUVE" || c.statutCommande === "REGLE"))
        setHandledOrders(commandes?.filter((c) => c.statutCommande === "RECEPTIONNE" || c.statutCommande === "DELIVRE"))
    }, [commandes]);

    const columns =
        [
            {
                title: "Numero de commande",
                dataIndex: "numero",
                key: "code",
                render: (_, record) => (<>{record?.codeId} </>),
            },
            {
                title: "Compagnie",
                dataIndex: "compagnie",
                key: "1",
                render: (_, record) => (<>{record?.compagnie?.raisonSociale} </>),
            },
            {
                title: "Montant",
                dataIndex: 'montant',
                key: 'montant',
                render: (_, record) => (
                    <>
                        {formatCurrency(record?.reglement?.montant)}
                    </>
                )
            },
            {
                title: "Statut commande",
                dataIndex: "statutCommande",
                key: "statutCommande",
                editable: false,
                render: (_, record) => (
                    <Tag color={getTagColor(record?.statutCommande)}>
                        {record?.statutCommande}
                    </Tag>
                ),
            },
            {
                title: "Date de Commande",
                dataIndex: "dateEmission",
                key: "dateEmission",
                editable: false,
                render: (_, record) => <>{formatFrenchDate(getAuthorizedDate(record?.actionsSurCommande))}</>,
            },
        ];
    const columnsReceived =
        [
            {
                title: "Numero de commande",
                dataIndex: "numero",
                key: "code",
                render: (_, record) => (<>{record?.codeId} </>),
            },
            {
                title: "Compagnie",
                dataIndex: "compagnie",
                key: "1",
                render: (_, record) => (<>{record?.compagnie?.raisonSociale} </>),
            },
            {
                title: "Montant",
                dataIndex: 'montant',
                key: 'montant',
                render: (_, record) => (
                    <>
                        {formatCurrency(record?.reglement?.montant)}
                    </>
                )
            },
            {
                title: "Date de Commande",
                dataIndex: "dateEmission",
                key: "dateEmission",
                editable: false,
                render: (_, record) => <>{formatFrenchDate(record?.dateEmission)}</>,
            },
        ];

    const expandedRowRender = (record) => (
        <div
            style={{
                padding: "16px", background: "#f9f9f9", display: "flex", justifyContent: "center", gap: "16px",
            }}
        >
            <Button
                type="default"
                style={{
                    backgroundColor: "#1a347d",
                    borderColor: "#4c757d",
                    color: "white",
                }}
                icon={<i className="bx bx-detail"></i>}
                onClick={() => {
                    setSelectedOrder(record);
                    navigate(`/commande/${record?.codeId}`)
                }}
            >
                Détails
            </Button>
        </div>)

    const oldColumns =
        [
            {
                title: "Initiée par",
                dataIndex: "initiateur",
                key: "initiateur",
                editable: false,
                render: (_, record) => (
                    <>
                        {
                            isConnectedUser(record?.actionsSurCommande) ? (
                                <>
                                    Vous
                                </>
                            ) : (
                                <>
                                    {getInitiator(record?.actionsSurCommande)?.personne?.nom} {getInitiator(record?.actionsSurCommande)?.personne?.prenom}
                                </>
                            )
                        }
                    </>
                )
            },
            {
                title: "Compagnie",
                dataIndex: "compagnie",
                key: "1",
                render: (_, record) => (<>{record?.compagnie.raisonSociale} </>),
            },
            {
                title: "Statut commande",
                dataIndex: "statutCommande",
                key: "statutCommande",
                editable: false,
                render: (_, record) => (
                    <Tag color={getTagColor(record.statutCommande)}>
                        {record.statutCommande}
                    </Tag>
                ),
            },
            {
                title: "Date de Commande",
                dataIndex: "dateEmission",
                key: "dateEmission",
                editable: false,
                render: (_, record) => <>{formatFrenchDate(record.dateEmission)}</>,
            },
        ];

    const validation = (lotA, updateCommentaire) => {
        setLoadingOrders(true)
        console.log("Code de la commande à valider :", lotA);
        const com = updateCommentaire;
        console.log(updateCommentaire);
        const validationBonCommandeDTO = {
            bonCommandeCodeId: lotA, commentaire: com,
        };
        console.log(validationBonCommandeDTO);
        validateWithComment(validationBonCommandeDTO)
            .then((r) => {
                setLoadingOrders(true)
                toast('Here')
                setReload(prevState => !prevState)
                toast("Commande validée avec succès !");
                setLoadingOrders(false)
            })
            .catch((error) => {
                console.error("Erreur lors de la validation :", error);
                setLoadingOrders(false)
                toast("Erreur lors de la validation !");

            });
        setLoadingOrders(false)
        //   setReload((prevState) => !prevState);

    };

    const commandesRecues = commandes?.filter((c) => c.statutCommande === "AUTORISE");
    const commandesRejetees = commandes?.filter((c) => c.statutCommande === "REJETE");
    const commandesEnCours = commandes?.filter((c) => c.statutCommande === "EN_TRAITEMENT" || c.statutCommande === "APPROUVE" || c.statutCommande === "REGLE");
    const commandesLivrees = commandes?.filter((c) => c.statutCommande === "RECEPTIONNE" || c.statutCommande === "DELIVRE");

    console.log(commandesEnCours)

    const onSubmit = (firstAttestation, lastAttestation, selectedTypeAttestation, selectedCategorie, nombre,) => {
        setLivrerLoading(true);
        if (firstAttestation > lastAttestation) {
            toast.error("le premier numéro d'attestation doit être inférieur au dernier numéro d'attestation",);
        }
        if (nombre === lastAttestation - firstAttestation + 1) {
            validation(selectedBonCommandeId, com);
            const catg = categories.find((element) => element.codeCategorie === selectedCategorie,);
            let lot = {
                compagnie: selectedCompagnie,
                lot: [firstAttestation, lastAttestation],
                updatedLot: [firstAttestation, lastAttestation],
                categorie: catg,
                typeAttestation: selectedTypeAttestation,
            };
            console.log("Loooot: ", lot);
            axiosInstance
                .post(`/api/lot-attestation`, JSON.stringify(lot))
                .then((res) => {
                    console.log("Data Ressst", res);
                    if (res.status === 226) {
                        toast("Ce numéro d'attestation existe déjà!");
                    } else {
                        setAffecterLotModal(false);
                        setReload(true);
                        toast("Lot d'attestation ajoutée avec succès");
                    }
                    setLivrerLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 226) {
                        toast("Ce numéro d'attestation existe déjà!");
                    } else {
                        toast("Erreur lors de l'ajout du lot d'attestation");
                    }
                    setLivrerLoading(false);
                });
        } else {
            setLivrerLoading(false);

            toast("Veuillez vérifier les valeurs que vous avez saisi!");
            toast(`Le nombre precis devrait etre ${lastAttestation - firstAttestation + 1}`,);
        }
    };

    return (
        <SinglePageLayout>
            <>
                <Tabs
                    defaultActiveKey="rec"
                    style={{ marginTop: 20 }}
                    items={[{
                        label: "Commandes recues", key: "rec", children: (
                            <Spin spinning={loadingOrders}>
                                <OrdersFiltering source={commandesRecues} setOrders={setReceivedOrders}
                                    orders={receivedOrders} />
                                <Table
                                    columns={columnsReceived}
                                    dataSource={receivedOrders}
                                    rowKey="codeId"
                                    expandable={{
                                        expandedRowRender,
                                    }}
                                />
                            </Spin>),
                    }, {
                        label: "Commandes en traitement", key: "ent", children: (
                            <Spin spinning={loadingOrders}>
                                <OrdersFiltering source={commandesEnCours} setOrders={setOnGoingOrders}
                                    orders={onGoingOrders} />
                                <Table
                                    columns={columns}
                                    dataSource={onGoingOrders}
                                    rowKey="codeId"
                                    expandable={{
                                        expandedRowRender,
                                    }}
                                />
                            </Spin>),
                    }, {
                        label: "Commandes traitées", key: "tra", children: (<Spin spinning={loadingOrders}>
                            <OrdersFiltering source={commandesLivrees} setOrders={setHandledOrders}
                                orders={handledOrders} />
                            <Table
                                columns={columns}
                                dataSource={handledOrders}
                                rowKey="codeId"
                                expandable={{
                                    expandedRowRender,
                                }}
                            />
                        </Spin>),
                    }, {
                        label: "Commandes rejetées", key: "rej", children: (<Spin spinning={loadingOrders}>
                            <OrdersFiltering source={commandesRejetees} setOrders={setRejectedOrders}
                                orders={rejectedOrders} />
                            <Table
                                columns={columns}
                                dataSource={rejectedOrders}
                                rowKey="codeId"
                                expandable={{
                                    expandedRowRender,
                                }}
                            />
                        </Spin>),
                    },]}
                />
            </>
            {/* <OrderTimeline
                actionsSurCommandes={selectedOrder?.actionsSurCommande}
                title={'Hey'}
                open={openTimeline}
                cancel={() => setOpenTimeline(false)}
                order={selectedOrder}
            />*/}
            <AffecterLotAttestation
                affectationModalOpen={affecterLotModal}
                categories={categories}
                compagnie={selectedOrder?.compagnie}
                loading={livrerLoading}
                onSubmit={onSubmit}
                handleAffectationModalClose={() => setAffecterLotModal(false)}
                categorie={selectedOrder?.categorie}
                typeAttestation={selectedOrder?.typeAttestation}
                nombre={selectedOrder?.nombre}
            >
                <div style={{ marginBottom: "1rem", marginTop: "5px" }}>
                    <label htmlFor="commentaire">Faites un commentaire :</label>
                    <textarea
                        id="commentaire"
                        style={{
                            width: "100%",
                            marginTop: "0.5rem",
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #d9d9d9",
                        }}
                        placeholder="Votre commentaire ici..."
                        onChange={(e) => {
                            com = e.target.value;
                        }}
                    />
                </div>
            </AffecterLotAttestation>

        </SinglePageLayout>
    );
};

export default CompaniesCommandes;
